<div class="login-logo">
  <img
    [src]="logoSrc()"
    alt="okcargo"
  />
</div>
